// Chakra imports
import {
  Flex,
  Box,
  Icon,
  Select,
  Text,
  useColorModeValue,
  IconButton,
} from '@chakra-ui/react';
import LineChart from 'components/charts/LineChart';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';

// Custom components
import Card from 'components/card/Card';
import {
  lineChartDataOverallRevenue,
  lineChartOptionsOverallRevenue,
} from 'variables/charts';
import { MdDownload, MdOutlineFavoriteBorder } from 'react-icons/md';
import Chart from "react-apexcharts";

// Assets
import { RiArrowUpSFill } from 'react-icons/ri';
import { useEffect, useRef, useState } from 'react';
import { type } from 'os';
import { useParams } from 'react-router-dom';

export default function OverallRevenue(props: { [x: string]: any }) {
  const { ...rest } = props;
  const { id } = useParams();
  //console.error(props.id);

  //let options =
  const [cate, setcate] = useState([1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]);
  const [total, settotal] = useState();
  const [catex, setcatex] = useState(['1991', '1992', '1993', '1994', '1995', '1996', '1997', '1998', '1999']);
  const Grafico = useRef(null);


  const [optionsx, setoptionsx] = useState({
    labels: catex,
    chart: {
      events: {
        click: (event: any, chartContext: { w: { config: { labels: { [x: string]: any; }; }; }; }, config: { dataPointIndex: string | number; }) => {
          alert(chartContext.w.config.labels[config.dataPointIndex])
        }
      }
    }


  })
  const [options, setoptions] = useState(
    {

      xaxis: {
        categories: cate
      },
      events: {
        selection: () => {
          alert('asdad')
        }
      }



      // events: {
      //   selection: ()=>{
      //     alert('asda');
      //   }
      // }

    }
  )
  //eslint-disable-next-line
  const [Line, setLine] = useState([
    {
      name: 'Reales',
      data: [200, 64, 48, 66, 49, 68]
    },
    {
      name: 'Esperados',
      data: [10, 40, 24, 46, 20, 46]
    }
  ]);

  const sendRandomData = async () => {
    const currentDate = new Date();
    const randNumber = Math.floor(Math.random() * 100);
    const showDate = moment(currentDate).format('HH:mm:ss');
    const doc = {
      time: showDate,
      bid: randNumber,
    }
    const formData = new FormData();
    formData.append('id', props.id);


    const response = await fetch(process.env.REACT_APP_URL_SERVER + '/votosxcasilla',
      {
        body: formData,
        method: "post",
        credentials: 'include',
      });

    const result = await response.json();

    //console.log(result.new_array)

    console.error(result);
    setcate(result.seccionesx)
    setoptionsx({
      labels:
        result.seccionesx
      , chart: {
        events: {
          click: (event: any, chartContext: { w: { config: { labels: { [x: string]: any; }; }; }; }, config: { dataPointIndex: string | number; }) => {
            //alert(chartContext.w.config.labels[config.dataPointIndex])
          }
        }
      }
    })
    setLine(result.votosx)

    let datosX = await fetch(process.env.REACT_APP_URL_SERVER + '/votos_confirmados', {
      method: 'GET',
      //  body: JSON.stringify(doc),
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })

    setcate(result.seccionesx)

    const resultX = await datosX.json();
    settotal(resultX.Total);
    //console.log(result.new_array)


  }
  const newOptions = {
    ...lineChartOptionsOverallRevenue,
    colors: ['var(--chakra-colors-brand-500)', '#39B8FF'],

  };

  const ApexChart = (data: any) => {
    return (
      <div>
        <Chart
          type="area"
          height={300}
          width='100%'
          series={[
            {
              name: "Commits",
              data: data?.map((data: { bid: any; }) => data.bid)
            }
          ]}

          options={{
            chart: {
              toolbar: {
                show: false
              },

            },
            colors: ['#f90000'],
            stroke: { width: 1, curve: 'smooth' },
            dataLabels: { enabled: false },
            xaxis: {
              categories: data?.map((data: { time: any; }) => data.time),

            },
            yaxis: {
              show: false,
            }
          }}
        />
      </div>
    )
  }
  // Chakra Color Mode
  useEffect(() => {
    const timer2 = setInterval(() => { sendRandomData() }, 4000);
    return () => { clearInterval(timer2) }
  }, [])
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  return (
    <Card
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      w="100%"
      mb={{ base: '20px', lg: '0px' }}
      {...rest}
    >
      <Flex justify="space-between" px="20px" pt="5px" w="100%">
        <Flex align="center" w="100%">
          <Flex flexDirection="column" me="20px">
            <Text
              color={textColor}
              fontSize="21px"
              fontWeight="700"
              lineHeight="100%"
            >
              Votos Confirmados: { total}
              {/* # ESTE APARTADO REFLEJARA NUMERO DE VOTOS POR CONTENDIENTE */}
            </Text>
            {/* <Text
              color="secondaryGray.600"
              fontSize="sm"
              fontWeight="500"
              mt="4px"
            >
              Incremento un:
            </Text> */}
          </Flex>
          {/* <Flex align="center">
            <Icon as={RiArrowUpSFill} color="green.500" me="2px" />
            <Text color="green.500" fontSize="sm" fontWeight="700">
              +2.45%
            </Text>
          </Flex> */}
        </Flex>
        <Select
          fontSize="sm"
          variant="subtle"
          defaultValue="monthly"
          width="unset"
          fontWeight="700"
        >
          <option value="daily">Diario</option>
          <option value="monthly">Mensual</option>
          <option value="yearly">Anual</option>
        </Select>

        <IconButton aria-label="1" me='2px' px='0px' variant='no-hover' bg='transparent' onClick={() => {

          setLine([
            {
              name: 'Esperados',
              data: [80, 44, 88, 26, 49, 68]
            },
            {
              name: 'Reales',
              data: [19, 20, 94, 96, 20, 46]
            }
          ])
          alert('EMPIEZA DESCARGA')
        }}>
          <Icon as={MdDownload} h='24px' w='24px' color='blue.300' />
        </IconButton>
      </Flex>
      <Box minH="260px" mt="auto" w="100%">
        <Chart
          options={optionsx}
          series={Line}
          type="bar"
        />
      </Box>
    </Card>
  );
}
